import { useAppSelector } from "@/shared/lib/redux"
import { selectSocialMarketPartners, selectSocialMarketPartnersLoading } from "../../model"
import { MarketplaceCard } from "@/shared/ui/marketplace-card"
import { useNavigate } from "react-router-dom"
import { Loader } from "@/shared/ui/loader"
import ArrowUpRightSvg from '@/shared/assets/images/ArrowUpRight.svg'

export const PartnersGrid = () => {
    const partners = useAppSelector(selectSocialMarketPartners)
    const partnersLoading = useAppSelector(selectSocialMarketPartnersLoading)
    const navigate = useNavigate()

    return (
        <>
            {Boolean(partners.length) &&
                <div className="grid grid-cols-12 gap-[10px] auto-rows-fr">
                    {partners.map(partner =>
                        <div key={partner.id} className="col-span-6 lg:col-span-4 xxl:col-span-4 screen:col-span-3">
                            <MarketplaceCard
                                image={partner.logo}
                                title={(
                                    <div className="flex items-center gap-2 justify-between">
                                        <div className="overflow-ellipsis overflow-hidden">
                                            {partner.name}
                                        </div>
                                        <div className="shrink-0">
                                            <a href={partner.href} className="text-color-primary">
                                                <ArrowUpRightSvg width={24} height={24} />
                                            </a>
                                        </div>
                                    </div>
                                )}
                                subtitle={"Проверенный партнер"}
                                description={(
                                    <div className="flex flex-col h-full">
                                        <div title={partner.description} className="max-h-[200px] w-full line-clamp-6 text-ellipsis h-full">
                                            {partner.description}
                                        </div>
                                        <div className="text-color-primary mt-5 hover:underline">
                                            <a href={partner.href} target="_blank">{partner.href}</a>
                                        </div>
                                    </div>
                                )}
                                buttonText={"Перейти"}
                                onClick={() => navigate(`/social-market/partners/${partner.id}`)}
                            />
                        </div>
                    )}
                </div>
            }
            {(!Boolean(partners.length) && partnersLoading) &&
                <Loader />
            }
            {(!Boolean(partners.length) && !partnersLoading) &&
                <div className="h-full flex items-center justify-center">
                    <div className="font-mediumttf -mt-[150px] bg-color-secondary rounded-2xl screen:rounded-3xl text-white py-6 px-8 text-2xl text-center">
                        НЕТ ДАННЫХ О <br /> ПАРТНЕРАХ
                    </div>
                </div>
            }
        </>
    )
}